import PartCustomSelect from './PartCustomSelect';

export default PartCustomSelect;
